import React, {useState, useEffect, useRef} from 'react';
import {useLocation} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const RecruitmentEventCandidateListComponent = (props) => {

  const {t} = props;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  const recruitmentId = queryParams.get('recruitmentId');
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);

      let extraQuery = '';

      if (type === 'new') {
        extraQuery += '&search[todo][operator]=equals&search[todo][value]=true';
      }

      if (type === 'dropout') {
        extraQuery += '&search[is_dropout][operator]=equals&search[is_dropout][value]=true';
      }

      if (type === 'results') {
        extraQuery += '&search[has_results][operator]=equals&search[has_results][value]=true';
      }

      if (recruitmentId) {
        extraQuery += '&search[recruitment_event.recruitment][operator]=equals&search[recruitment_event.recruitment][value]=' + recruitmentId;
      }

      apiCall('get', '/api/v2/recruitment-event-candidate' + query + extraQuery)
        .then(response => {
          let items = response.data.data.items || [];
          if (type === 'new') {
            items = items.filter(item => item.todo === true);
          }
          if (type === 'dropout') {
            items = items.filter(item => item.is_dropout === true);
          }
          if (type === 'results') {
            items = items.filter(item => item.has_results === true);
          }
          if (recruitmentId) {
            items = items.filter(item => String(item.recruitment_event?.recruitment?.id) === String(recruitmentId));
          }
          setTotalRecords(items.length);
          setCandidates(items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => {
                    setRows(e.target.value);
                    setLazyParams({
                      ...lazyParams,
                      rows: e.target.value,
                      first: 0,
                      page: 0
                    });
                  }}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, type, recruitmentId, window.App.state.rerenderRecruitmentEventCandidateList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={candidates} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column header={t('columnCandidate')} sortable filter
          body={(rowData) => {
            return <>{rowData.candidate?.name}</>
          }}
        />

        <Column header={t('columnEmail')}
          body={(rowData) => {
            return <>{rowData.candidate?.email}</>
          }}
        />

        <Column header={t('columnEvent')}
          body={(rowData) => {
            return <>{rowData.recruitment_event?.name}</>
          }}
        />

        <Column header={t('columnStatus2')}
          body={(rowData) => {
            return <>{rowData.status?.name || '-'}</>
          }}
        />

        <Column header={t('columnTask')}
          body={(rowData) => {
            return rowData.todo ? <i className="pi pi-check text-success"/> : <i className="pi pi-times text-danger"/>
          }}
        />

        <Column header={t('columnDropped')}
          body={(rowData) => {
            return rowData.is_dropout ? <i className="pi pi-check text-danger"/> : <i className="pi pi-times text-success"/>
          }}
        />

        <Column header={t('columnHasResult')}
          body={(rowData) => {
            return rowData.has_results ? <i className="pi pi-check text-success"/> : <i className="pi pi-times text-danger"/>
          }}
        />
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(RecruitmentEventCandidateListComponent);
